export function downloadURL(url: string, name: string) {
  let link: any = document.createElement('a');
  link.download = name;
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  link = null;
}
